import { gql, useMutation } from 'urql';

export const UPDATE_SETTINGS_MUTATION = gql`
  mutation UpdateSettings($eventId: Int!, $formData: UpdateSetting!) {
    updateSettings(eventId: $eventId, formData: $formData) {
      id
      eventId
      showFioInApp
      sendTicketAfterAcceptAt
      invitationExpiresAt
      ticketDeliveryMessage
      ticketDeliveryMethod
      sendTicketsOnEventDayAt
    }
  }
`;

export enum TicketDeliveryMethod {
  SMS = 'SMS',
  Email = 'EMAIL',
  Both = 'BOTH',
  VK = 'VK',
}

export interface UpdateSettingInput {
  showFioInApp?: boolean | null;
  skipTicketsOnAccept?: boolean | null;
  sendTicketAfterAcceptAt?: string | null;
  invitationExpiresAt?: string | null;
  ticketDeliveryMessage?: string | null;
  emailTicketDeliveryMessage?: string | null;
  ticketDeliveryMethod?: TicketDeliveryMethod[] | null;
  inviteAcceptionInfo?: string | null;
  invitationEmailSubject?: string | null;
  ticketEmailSubject?: string | null;
  calendarMeetingDescription?: string | null;
  calendarMeetingDateStart?: string | null;
  calendarMeetingDateEnd?: string | null;
  calendarMeetingPoint?: string | null;
  sendTicketsOnEventDayAt?: string | null;
}

export interface UpdateSettingsVars {
  eventId: number;
  formData: UpdateSettingInput;
}

export interface UpdateSettingsResponse {
  updateSettings: {
    id: number;
    eventId: number;
    showFioInApp: boolean | null;
    sendTicketAfterAcceptAt: string | null;
    invitationExpiresAt: string | null;
    ticketDeliveryMessage: string | null;
    ticketDeliveryMethod: TicketDeliveryMethod[] | null;
    sendTicketsOnEventDayAt: string | null;
  };
}

export const useUpdateSettings = () => {
  const [{ data, error, fetching }, executeMutation] = useMutation<UpdateSettingsResponse, UpdateSettingsVars>(
    UPDATE_SETTINGS_MUTATION
  );

  const updateSettings = async (variables: UpdateSettingsVars, onError?: () => void) => {
    const result = await executeMutation(variables);

    if (result.error) {
      if (onError) {
        onError();
      }
      throw result.error;
    }

    return result;
  };

  return {
    data: data?.updateSettings,
    error,
    fetching,
    updateSettings,
  };
};
